import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Inject, Input, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1 from '@lvflanders/bar-ng-ui';
import { BarControlsModule } from '@lvflanders/bar-ng-ui';

class StartschermChatComponent {
    constructor(document, elementRef) {
        this.document = document;
        this.elementRef = elementRef;
    }
    ngAfterViewInit() {
        this.loadChatWithScript();
    }
    loadChatWithScript() {
        let chatScript = document.createElement("script");
        let opts = this.extractData(this.options);
        chatScript.type = "text/javascript";
        chatScript.async = true;
        let url = "https://www.socialintents.com/api/socialintents.1.3.js#";
        if (opts && opts.key) {
            url = url + opts.key;
        }
        else {
            console.warn("Er is geen chatkey meegegeven, we gebruiken de standaard");
            url = url + "2c9fa6c373e55e5e0173e748ff4e02ed";
        }
        //chatScript.src = "http://www.socialintents.com/api/socialintents.1.3.js#2c9faa357398634601739fd80a910f51";
        chatScript.src = url;
        document.body.appendChild(chatScript);
        let chatScriptConfiguration = document.createElement("script");
        chatScriptConfiguration.type = "text/javascript";
        chatScriptConfiguration.async = true;
        chatScriptConfiguration.innerHTML = "window.FCSP = 'some-key-123'";
        document.body.appendChild(chatScriptConfiguration);
    }
    extractData(data) {
        var result = {};
        if (data) {
            if (data.apikey) {
                result.key = data.apikey;
            }
        }
        return result;
    }
}
StartschermChatComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermChatComponent, deps: [{ token: DOCUMENT }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
StartschermChatComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: StartschermChatComponent, selector: "startscherm-chat", inputs: { options: "options" }, ngImport: i0, template: "<script src=\"//www.socialintents.com/api/socialintents.1.3.js#2c9faa357398634601739fd80a910f51\" async=\"async\"></script>", styles: [""], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermChatComponent, decorators: [{
            type: Component,
            args: [{ selector: 'startscherm-chat', encapsulation: ViewEncapsulation.None, template: "<script src=\"//www.socialintents.com/api/socialintents.1.3.js#2c9faa357398634601739fd80a910f51\" async=\"async\"></script>" }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }, { type: i0.ElementRef }];
    }, propDecorators: { options: [{
                type: Input
            }] } });

class StartschermChatModule {
    static forRoot() {
        return {
            ngModule: StartschermChatModule,
            providers: []
        };
    }
}
StartschermChatModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermChatModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StartschermChatModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: StartschermChatModule, declarations: [StartschermChatComponent], imports: [CommonModule, i1.BarControlsModule], exports: [StartschermChatComponent] });
StartschermChatModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermChatModule, imports: [CommonModule,
        BarControlsModule.forRoot()] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermChatModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        StartschermChatComponent
                    ],
                    exports: [
                        StartschermChatComponent
                    ],
                    imports: [
                        CommonModule,
                        BarControlsModule.forRoot()
                    ]
                }]
        }] });

/*
 * Public API Surface of @lvflanders/startscherm-chat-ng-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { StartschermChatComponent, StartschermChatModule };
//# sourceMappingURL=lvflanders-startscherm-chat-ng-ui.mjs.map
